/* eslint-disable local/no-new-type-assertions */
import type { MessageType } from '@/client/services/conversation'
import getMessageConfig from '@/client/services/conversation/getMessageConfig'
import type { MessageEmbedV1MessageFragment } from '@/client/services/hasura/generated/graphql'

import MessageEmbedV1Assessment from './MessageEmbedV1Assessment/MessageEmbedV1Assessment'

export const MESSAGE_EMBED_TYPE: MessageType = 'embed-v1'

export default function MessageEmbedV1({
  message,
}: {
  message: MessageEmbedV1MessageFragment
}): React.ReactElement | null {
  const messageConfig = getMessageConfig({
    type: message.type as MessageType,
    body: message.body_safe,
  })

  if (messageConfig == null || messageConfig.type !== 'embed-v1') {
    return null
  }

  const { embed } = messageConfig.body

  if (embed === 'assessment') {
    return <MessageEmbedV1Assessment message={message} />
  }

  return null
}
